export default __webpack_public_path__ + "static/media/GPS_02.643d76d7.png";